import { api } from './client';
import type { StatsResponse, RecentScansResponse } from './types';

export function getStats() {
  return api.get<StatsResponse>('/api/admin/stats');
}

export function getRecentScans() {
  return api.get<RecentScansResponse>('/api/admin/recent-scans');
}
